import { render } from "./upload.vue?vue&type=template&id=6f0c60cc"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"
script.render = render

export default script